import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dropdown,
  Form,
  Header,
  Icon,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow
} from 'semantic-ui-react';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";

interface ReceiptDetailProps {
  id : string;
  ERP_number : string;
  model : number;
  model_info : string;
  model_name : string;
  product_name  : string;
  receipt : number;
  serial_number : string;
  symptom : string;
  sypmtom_detail : string;
  cancel: string;
  receipt_step: string;

}

interface ReceiptCheckProps {
  id: string;
  ERP_receipt_code: string;
  address: string;
  company_register_number:  string;
  customer: string;
  email: string;
  is_info_agree : boolean;
  phone_number: string;
  receipt_category: string;
  receipt_name: string;
  receiption_date: string;
  zone_code: string;
  receiptNumber: string;
  get_receipted_number : number;
  is_finished: boolean;
  receiptDetail: ReceiptDetailProps[];
}
interface CancelConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (cancelReason: string, cancelReasonDetail?: string) => void;
  cancelReceiptDetail: ReceiptDetailProps[];
}

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

const ReceiptCheck = () => {
  const navigate = useNavigate();
  const [receiptName, setReceiptName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [receiptList, setReceiptList] = useState<ReceiptCheckProps[]>();
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [cancelReceiptDetail, setCancelReceiptDetail] = useState<ReceiptDetailProps[]>([])
  const [modalOpen, setModalOpen] = useState(false);

  const [cancelReason, setCancelReason] = useState<string>('');
  const [cancelReasonDetail, setCancelReasonDetail] = useState<string>('');

  useEffect(() => {
    setReceiptList(undefined);
    setReceiptName(sessionStorage.getItem('receiptNameForReceiptCheck') || '');
    setPhoneNumber(sessionStorage.getItem('phoneNumberForReceiptCheck') || '');

  }, []);

  const CancelConfirmModal: React.FC<CancelConfirmModalProps> = ({
    open,
    onClose,
    onConfirm,
    cancelReceiptDetail
  }) => {

    // 취소사유 옵션
    const cancelReasonOptions = [
      { key: 'normal', value: '정상작동', text: '정상작동' },
      { key: 'wrong', value: '오접수', text: '오접수' },
      { key: 'duplicated_receipt', value: '중복접수', text: '중복접수' },
      { key: 'later', value: '재접수 예정', text: '재접수 예정' }
    ];

    const handleConfirm = () => {
      if (!cancelReason) {
        alert('취소사유를 선택해주세요.');
        return;
      }

      onConfirm(cancelReason, cancelReasonDetail);
    };

    const handleClose = () => {
      setCancelReason('');
      setCancelReasonDetail('');
      onClose();
    };
    return (
      <Modal
        open={open}
        onClose={onClose}
        closeOnDimmerClick={true} // 모달 밖 클릭시 닫힘
        size="large"
      >
        <Modal.Header>
          <Icon name="warning sign" color="red" />
          접수 취소 확인
        </Modal.Header>

        <Modal.Content>
          <Header as="h4" color="red">
            다음 접수내역을 정말로 취소하시겠습니까?
          </Header>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            취소 후에는 복구가 불가능하며, 재접수시 방문이 늦어질 수 있습니다.
          </p>

          {cancelReceiptDetail && cancelReceiptDetail.length > 0 ? (
            <Table celled striped>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>접수번호</Table.HeaderCell>
                  <Table.HeaderCell>제품명</Table.HeaderCell>
                  <Table.HeaderCell>모델명</Table.HeaderCell>
                  <Table.HeaderCell>옵션정보</Table.HeaderCell>
                  <Table.HeaderCell>상태</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                {cancelReceiptDetail.map((detail, index) => (
                  <Table.Row key={detail.id || index}>
                    <Table.Cell>
                      <strong>{detail.receipt} - {detail.ERP_number}</strong>
                    </Table.Cell>
                    <Table.Cell>{detail.product_name || '-'}</Table.Cell>
                    <Table.Cell>{detail.model_name || '-'}</Table.Cell>
                    <Table.Cell>{detail.model_info || '-'}</Table.Cell>
                    <Table.Cell>
                      <span style={{ color: '#f2711c' }}>
                        {detail.receipt_step || '접수중'}
                      </span>
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          ) : (
            <p>선택된 접수내역이 없습니다.</p>
          )}

          <div style={{
            background: '#fff6f6',
            border: '1px solid #e0b4b4',
            borderRadius: '4px',
            padding: '14px',
            marginTop: '20px'
          }}>
            <strong>총 {cancelReceiptDetail?.length || 0}건의 접수를 취소합니다.</strong>
          </div>

          {/* 취소사유 선택 폼 */}
          <Form style={{ marginTop: '20px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '4px' }}>
            <Header as="h4" color="orange">
              <Icon name="edit" />
              취소사유 입력
            </Header>

            <Form.Field required>
              <label>취소사유</label>
              <Dropdown
                placeholder='취소사유를 선택해주세요'
                fluid
                selection
                options={cancelReasonOptions}
                value={cancelReason}
                onChange={(e, { value }) => setCancelReason(value as string)}
              />
            </Form.Field>
          </Form>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={handleClose}>
            <Icon name="remove" /> 취소
          </Button>
          <Button
            color="red"
            onClick={handleConfirm}
            disabled={!cancelReceiptDetail || cancelReceiptDetail.length === 0 || !cancelReason}
          >
            <Icon name="checkmark" /> 확인
          </Button>
        </Modal.Actions>
      </Modal>
    );
  };

  const days_between = (date1: any, date2: any): number => {

    // The number of milliseconds in one day
    const ONE_DAY = 1000 * 60 * 60 * 24;

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(date1 - date2);

    // Convert back to days and return
    return Math.round(differenceMs / ONE_DAY);

  }

  const handleModalConfirm = async () => {
    try {
      const requestData = {
        cancelIds: cancelReceiptDetail.map(detail => detail.id),
        cancelReason: cancelReason,
        ...(cancelReasonDetail && { cancelReasonDetail: cancelReasonDetail.trim() })
      };

      const response = await axios.put(`${apiEndpoint}/receiption/api/receiptCheck/`, requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // 성공 시뮬레이션
      setTimeout(() => {
        alert('취소처리가 완료되었습니다.');
        setCancelReceiptDetail([]);
        setModalOpen(false);
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('API 호출 중 오류 발생:', error);
      alert('취소 처리 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('receiptName', receiptName);
    formData.append('phoneNumber', phoneNumber);

    await axios.post(`${apiEndpoint}/receiption/api/receiptCheck/`, formData, {
      headers: {'Content-Type': 'multipart/form-data',},
      }).then(response => {
        const filteredData = response.data.filter((item: ReceiptCheckProps) => item.is_finished === false);
        const data = filteredData.map((item: ReceiptCheckProps) => {
          let receiptDetail = item.receiptDetail.filter((detail: ReceiptDetailProps) => {
            if ((detail.receipt_step === '취소중' || detail.receipt_step === '취소완료') && (days_between(new Date(), new Date(item.receiption_date)) > 7)) {
              return false;
            }
            else {
              return true;
            }
          });
          return {...item, receiptDetail}
        })

        setReceiptList(data);
        setIsButtonClicked(true);
        console.log(data)
      })
      .catch(error => {
        console.error('API 호출 중 오류 발생:', error);
      });

  };

  const genReceiptResultTable = () => {

    const cancelButtonHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
      // 선택된 항목이 있는지 확인
      if (!cancelReceiptDetail || cancelReceiptDetail.length === 0) {
        alert('취소할 접수내역을 선택해주세요.');
        return;
      }

      // 모달 열기
      setModalOpen(true);
    };



    let dataCnt = 0
    receiptList?.forEach((item) => dataCnt = dataCnt + item.receiptDetail.length)

    const goDetail = (data : any, i:any) => {
      navigate(`/receipt/${data[i].id}`, {state: {'isValid':true}})
    }

    const handleCancelIds = (e: React.ChangeEvent<HTMLInputElement>, receiptDetail: ReceiptDetailProps) => {
      const isChecked = e.target.checked;

      setCancelReceiptDetail(prev => {
        const currentList = prev || [];

        if (isChecked) {
          // 이미 존재하는지 확인 후 추가
          const exists = currentList.some(data => data.id === receiptDetail.id);
          return exists ? currentList : [...currentList, receiptDetail];
        } else {
          // 체크 해제 시 제거
          return currentList.filter(data => data.id !== receiptDetail.id);
        }
      });
    };

    if (dataCnt === 0 && isButtonClicked) {
      return (
        <div style={{color : 'red'}}>
          <h3>조회 결과가 없습니다.</h3>
        </div>
      )

    } else if (receiptList && receiptList.length > 0) {
      const ReceiptTableList = [] as any;
      const genReciptTable = () => {

          for (let i=0; receiptList && i < receiptList?.length; i++) {
            for (let j=0; j < receiptList[i].receiptDetail.length; j++) {
              const receiptStep = receiptList[i].receiptDetail[j].receipt_step;

              if (receiptStep === '접수중') {
                if (j === 0) {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}}>
                      <TableCell onClick={() => goDetail(receiptList, i)} rowSpan={receiptList[i].receiptDetail.length}>{receiptList[i].receiption_date}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                )} else {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}}>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                  )
                }
              } else if (receiptStep === '접수완료') {
                if (j === 0) {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} warning>
                      <TableCell onClick={() => goDetail(receiptList, i)} rowSpan={receiptList[i].receiptDetail.length}>{receiptList[i].receiption_date}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                )} else {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} warning>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                  )
                }
              } else if (receiptStep === '취소중') {
                if (j === 0) {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} negative onClick={() => goDetail(receiptList, i)}>
                      <TableCell rowSpan={receiptList[i].receiptDetail.length}>{receiptList[i].receiption_date}</TableCell>
                      <TableCell>{j+1}</TableCell>
                      <TableCell>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell><span style={{ color : 'red' }}>{receiptStep}</span></TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                )} else {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} negative onClick={() => goDetail(receiptList, i)}>
                      <TableCell>{j+1}</TableCell>
                      <TableCell>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell><span style={{ color : 'red' }}>{receiptStep}</span></TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  )
                }
              } else if (receiptStep === '취소완료') {
                if (j === 0) {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} negative onClick={() => goDetail(receiptList, i)}>
                      <TableCell rowSpan={receiptList[i].receiptDetail.length}>{receiptList[i].receiption_date}</TableCell>
                      <TableCell>{j+1}</TableCell>
                      <TableCell>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell><span style={{ color : 'red' }}>{receiptStep}</span></TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                )} else {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} negative onClick={() => goDetail(receiptList, i)}>
                      <TableCell>{j+1}</TableCell>
                      <TableCell>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell><span style={{ color : 'red' }}>{receiptStep}</span></TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  )
                }
              } else { // 배정완료
                if (j === 0) {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} positive>
                      <TableCell onClick={() => goDetail(receiptList, i)} rowSpan={receiptList[i].receiptDetail.length}>{receiptList[i].receiption_date}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                )} else {
                  ReceiptTableList.push(
                    <TableRow textAlign='center' style={{'cursor':'pointer'}} positive>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{j+1}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>({receiptList[i].receiptDetail[j].product_name}){receiptList[i].receiptDetail[j].model_name}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptList[i].receiptDetail[j].symptom}</TableCell>
                      <TableCell onClick={() => goDetail(receiptList, i)}>{receiptStep}</TableCell>
                      <TableCell><input type='checkbox' onChange={(e) => handleCancelIds(e, receiptList[i].receiptDetail[j])}/></TableCell>
                    </TableRow>
                  )
                }
              }

          }
        }
        return ReceiptTableList
      }

      return (
        <div>
          <h2>{receiptList && receiptList[0]?.customer}</h2>
          <div id='container' style={{ width: "100%", overflowX: "scroll" }}>

          <Table size='small' celled structured color='orange' padded unstackable selectable>

            <TableHeader>
              <TableRow textAlign='center'>
                <TableHeaderCell className='smaller'>접수날짜</TableHeaderCell>
                <TableHeaderCell className='smaller'>No</TableHeaderCell>
                <TableHeaderCell className='smaller'>모델</TableHeaderCell>
                <TableHeaderCell className='smaller'>접수내용</TableHeaderCell>
                <TableHeaderCell className='smaller'>단계</TableHeaderCell>
                <TableHeaderCell className='smaller'><Icon name="close"/></TableHeaderCell>
              </TableRow>
            </TableHeader>

            <TableBody className='smaller'>
              {genReciptTable()}
            </TableBody>

          </Table>
          <div className='flex' style={{ justifyContent: 'flex-end', margin:'10px 0px', padding:'5px'}}>
            <Button
            negative
            onClick={cancelButtonHandler}
            >취소하기</Button>
          </div>
          </div>
      </div>

      )
    } else {
      return (
        <div></div>
      )
    }
  }

  return (
    <>
      <CancelConfirmModal
        open={modalOpen}
        onClose={handleModalClose}
        onConfirm={handleModalConfirm}
        cancelReceiptDetail={cancelReceiptDetail}
      />
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "center",}} >
      <div style={{ width: "90%", maxWidth: "700px", }}>
        <h1 className="align-center my-4" style={{cursor:'pointer'}} onClick={() => navigate('/')}>내 접수내역 확인</h1>

        <div className="ui divider"/>
        <div className="card p-4">
            <Form onSubmit={handleSubmit}>
              <Form.Field>
                <label>접수자명</label>
                <input
                  placeholder=' 접수자명을 입력해주세요.'
                  type="text"
                  value={receiptName}
                  onChange={(e) => {
                    setReceiptName(e.target.value)
                    sessionStorage.setItem('receiptNameForReceiptCheck', e.target.value)
                  }}
                />
              </Form.Field>
              <Form.Field>
                <label>핸드폰번호</label>
                <input
                  placeholder=" '-' 없이 입력해주세요."
                  type="text"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value)
                    sessionStorage.setItem('phoneNumberForReceiptCheck', e.target.value)
                  }}
                />
              </Form.Field>
            <Button color='orange' type='submit'>확인</Button>
            </Form>


        </div>

        {genReceiptResultTable()}

        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}
      </div>
    </div>
    </>

  )
}

export default ReceiptCheck;